<template>
    <div
        class="sidebar mobile-side-nav"
        :class="{ open: open }"
    >
        <div class="mobile-side-nav-logo">
            <svg-vue class="logo" icon="logo" />
        </div>
        <base-sidebar-navigation />
    </div>
</template>

<script>
export default {
    props: {
        open: Boolean,
    },
};
</script>
